import * as FilesActionTypes from '../../types/files';

/**
 * Sets the files
 * @param {Object} payload {<fileId>: <fileData>}
 */
export const setFiles = (payload) => ({
    type: FilesActionTypes.SET_FILES,
    payload
});
